<template>
  <v-card class="elevation-0">
    <v-card-title>
      Buku, Jurnal, Produk Hukum, Etc
      <v-spacer></v-spacer>
      <v-text-field
        v-on:keyup.enter="searchOnEnter"
        v-on:blur="searchOnEnter"
        append-icon="mdi-magnify"
        hint="Kode, Deskripsi (press ENTER to search)"
        label="Search"
      ></v-text-field>

    </v-card-title>
    <!--    :search="search"-->
    <v-data-table
      v-model="selectedItems"
      :single-select="!multiSelect"
      :show-select="multiSelect"
      :headers="headers"
      :items="fArticlesFiltered"
      :page.sync="currentPage"
      :items-per-page="pageSize"
      hide-default-footer
      class="elevation-0"
      @page-count="totalTablePages = totalPaginationPages"
    >
      <template v-slot:top>
        <v-row align="center" class="ml-4 mr-4">
          <v-switch
            v-model="multiSelect"
            :label="multiSelect ? 'Multi Select' : 'Single Select'"
            x-small
            class="pa-3"
          ></v-switch>
          <v-btn
            fab
            dark
            color="red accent-4"
            x-small
            :disabled="!multiSelect"
            class="mr-2"
            @click="deleteDialogMultiShow"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn
            fab
            dark
            color="green"
            x-small
            @click="showDialogNew"
            :disabled="multiSelect"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-row>
      </template>
      <template v-slot:[`item.number`]="{ index }">
        {{ index + (currentPage - 1) * pageSize + 1 }}
      </template>
      <template v-slot:[`item.description`]="{ item }">
        <div>
          <div class="subtitle-2">{{ item.description }}</div>
          <div class="d-flex">
            <div class="caption blue--text">{{ item.authors }}</div>
            <v-btn
                class="blue elevation-6 ml-2"
                icon
                x-small>
              <a :href="`${downloadFile(item.fileName)}`"
                target="_blank"
              ><v-icon color="white" x-small>mdi-download</v-icon>
              </a>
            </v-btn>
          </div>
        </div>
      </template>
      <template v-slot:[`item.data`]="{ item }">
        <div>
          <div v-if="item.volume !== ''">Volume : {{ item.volume }}</div>
          <div v-if="item.issues !== ''">Issues : {{ item.issues }}</div>
          <div v-if="item.pages !== ''">Pages : {{ item.pages }}</div>
         <div v-if="item.doi !== ''"> DOI : {{ item.doi }}</div>
        </div>
      </template>
      <template v-slot:[`item.publikasi`]="{ item }">
        <div>
          <div>Tanggal : {{ item.publicationDate }}</div>
          <div>Penerbit : {{ item.publisher }}</div>
        </div>
      </template>

      <template v-slot:[`item.fdivisionBean`]="{ item }">
        <div>
          {{ lookupFDivision(item.fdivisionBean) }}
        </div>
        <v-chip :color="getColorStatusActive(item.statusActive)" dark small>
          {{ item.statusActive === true ? "Aktif" : "-" }}
        </v-chip>
      </template>
      <template v-slot:[`item.avatarImage`]="{ item }">
        <v-img
          :lazy-src="lookupImageUrlLazy(item)"
          :src="lookupImageUrl(item)"
          alt="avatar"
          width="70px"
          height="70px"
          class="ma-2 rounded"
        >
        </v-img>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="showDialogEdit(item)" icon :disabled="multiSelect">
          <v-icon small color="warning"> mdi-pencil </v-icon>
        </v-btn>

        <v-btn @click="deleteDialogShow(item)" icon :disabled="multiSelect">
          <v-icon small color="red accent-4"> mdi-delete </v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <!--    @page-count="pageCount = $event"-->

    <v-container>
      <v-row justify="end" align="center">
        <v-col cols="4" md="2" sm="2">
          <v-select
            v-model="pageSize"
            :items="pageSizes"
            label="Items per page"
          ></v-select>
        </v-col>
        <v-col cols="10" md="9" sm="8" align="right">
          <v-pagination
            v-model="currentPage"
            :length="totalPaginationPages"
            total-visible="8"
            circle
          ></v-pagination>
        </v-col>
      </v-row>
    </v-container>

    <delete-dialog
      ref="refDeleteConfirmDialog"
      @eventFromDeleteConfirmDialog1="deleteItemConfirmedSingleSelect"
      @eventFromDeleteConfirmDialog2="deleteItemConfirmedMultiSelect"
    ></delete-dialog>

    <FArticleDialog
      :formMode.sync="formMode"
      ref="refFormDialog"
      @eventFromFormDialogNew="saveDataNew"
      @eventFromFormDialogEdit="saveDataEdit"
    ></FArticleDialog>

    <v-snackbar v-model="snackbar">
      {{ snackBarMesage }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>
  
  <script>
import FArticleService from "@/services/apiservices-library/f-article-service";
import FDivisionService from "@/services/apiservices/f-division-service";
import DeleteDialog from "@/components/utils/DeleteConfirmDialog.vue";
import FArticleDialog from "./FArticleDialog.vue";
import FormMode from "@/models/form-mode";
import FArticle from "@/models/f-article";
import FileService from "@/services/apiservices/file-service";
import FArticleCategService from "@/services/apiservices-library/f-article-categ-service";

export default {
  components: { FArticleDialog, DeleteDialog },
  data() {
    return {
      snackbar: false,
      snackBarMesage: "",

      multiSelect: false,
      selectedItems: [],

      currentPage: 1,
      totalTablePages: 1,
      totalPaginationPages: 1,
      pageSize: 10,
      pageSizes: [10, 25, 50, 150, 500],
      itemsFCountry: [],

      search: "",
      headers: [
        {
          text: "No",
          align: "start",
          sortable: false,
          value: "number",
          width:"8%"
        },
        { text: "", value: "avatarImage", width:"8%" },
        { text: "Judul Jurnal/Artikel", value: "description", width:"25%" },
        { text: "Data", value: "data", width:"20%" },
        { text: "Publikasi", value: "publikasi", width:"18%" },
        // { text: "Download", value: "download", width:"12%", align: "center", sortable: false },
        { text: "Actions", value: "actions", sortable: false, width:"10%" },
      ],

      formMode: "",
      itemSelectedIndex: -1,
      itemSelected: "",
      itemsFArticleCateg:[],
      fArticles: [new FArticle(0, "", "")],
      itemsFDivision: [
        { id: 1, kode1: "", description: "" },
        { id: 2, kode1: "", description: "" },
      ],
    };
  },
  watch: {
    currentPage: {
      handler: function (value) {
        if (value) this.fetchFArticle();
      },
    },
    pageSize: {
      handler: function (value) {
        const refreshData = this.currentPage === 1;
        this.currentPage = 1;
        if (refreshData) {
          console.log("Change PageSize " + value);
          this.fetchFArticle();
        }
      },
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    fArticlesFiltered() {
      return this.fArticles;
    },
  },
  methods: {
    downloadFile(item) {
      // console.log(item);
      return FileService.file_url(item);
    },
    searchOnEnter(event) {
      if (this.search !== event.target.value) {
        this.currentPage = 1;
        this.search = event.target.value;
        this.fetchFArticle();
      }
    },
    fetchParent() {
      if (this.currentUser.organizationLevel === "DIV") {
        FDivisionService.getFDivisionById(this.currentUser.fdivisionBean).then(
            (response) => {
              this.itemsFDivision = [response.data];
            },
            (error) => {
              console.log(error.response);
            }
        );
        FArticleCategService.getAllFArticleCategByDivision(this.currentUser.fdivisionBean).then(
            (response) => {
              this.itemsFArticleCateg = response.data;
            },
            (error) => {
              console.log(error.response);
            }
        );
      } else {
        FDivisionService.getAllFDivision().then(
            (response) => {
              this.itemsFDivision = response.data;
            },
            (error) => {
              console.log(error.response);
            }
        );
        FArticleCategService.getAllFArticleCateg().then(
            (response) => {
              this.itemsFArticleCateg = response.data;
            },
            (error) => {
              console.log(error.response);
            }
        );
      }
    },
    fetchFCountry() {
      fetch('https://restcountries.com/v3.1/all?fields=name,idd,cca2,cca3,region,subregion,timezones,languages')
          .then(response => response.json())
          .then(data => {
            data.forEach(country => {
              let name = country.name.common;
              let description = country.name.official;
              let region = country.region;

              let countryCode = parseInt((country.idd.root + (country.idd.suffixes ? country.idd.suffixes[0] : '')).replace('+', ''), 10);
              this.itemsFCountry.push({id: countryCode, countryCode: countryCode, kode1: name, kode2:country.cca2, description: description,
                region: region,subregion:country.subregion, timeZone: country.timezones, languages: country.languages
              })

            });
          })
          .catch(error => console.error('Error:', error));
    },
    fetchFArticle() {
      FArticleService.getAllFArticleContaining(
        this.currentPage,
        this.pageSize,
        "id",
        "DESC",
        this.search
      ).then(
        (response) => {
          const { items, totalPages } = response.data;
          this.fArticles = items;
          this.totalPaginationPages = totalPages;
        },
        (error) => {
          console.log(error.response);
          if (error.response.statusCode === 401) {
            this.snackBarMesage = "Anda tidak mempunyai Akses!!";
            this.snackbar = true;
          }
        }
      );
    },
    linkNeated(link) {
      return link.replace(/\s+/g, "-").toLocaleLowerCase();
    },

    showDialogNew() {
      this.itemSelectedIndex = -1;
      const itemModified = Object.assign({}, "");
      // this.formDialogShow = true
      this.formMode = FormMode.NEW_FORM;
      this.$refs.refFormDialog.showDialog(
          this.itemSelectedIndex,
          itemModified,
          this.itemsFDivision,
          this.itemsFCountry,
          this.itemsFArticleCateg
      );
    },
    saveDataNew(itemFromRest) {
      this.itemSelected = itemFromRest;
      this.closeDialog();
      /**
       * Setiap data baru harus terlihat
       */
      this.fetchFArticle();
    },

    showDialogEdit(item) {
      this.itemSelectedIndex = this.fArticlesFiltered.indexOf(item);
      const itemModified = Object.assign({}, item);
      this.formMode = FormMode.EDIT_FORM;
      this.$refs.refFormDialog.showDialog(
          this.itemSelectedIndex,
          itemModified,
          this.itemsFDivision,
          this.itemsFCountry,
          this.itemsFArticleCateg
      );
    },
    saveDataEdit(item) {
      this.itemSelected = item;
      try {
        Object.assign(this.fArticles[this.itemSelectedIndex], this.itemSelected);
      } catch (e) {
        this.fetchFArticle();
        e.toString();
      }
      this.closeDialog();
    },

    deleteDialogShow(item) {
      this.itemSelectedIndex = this.fArticlesFiltered.indexOf(item);
      this.itemSelected = Object.assign({}, item);
      this.$refs.refDeleteConfirmDialog.showDialog(
        this.itemSelectedIndex,
        item.username
      );
    },
    deleteDialogMultiShow() {
      if (this.multiSelect === true) {
        this.$refs.refDeleteConfirmDialog.showDialogMulti(
          this.selectedItems,
          `${this.selectedItems.length} items selected`
        );
      }
    },
    deleteItemConfirmedSingleSelect(index) {
      console.log("delete SingleItem: " + index);

      const deletedItem = this.fArticles[this.itemSelectedIndex];
      FArticleService.deleteFArticle(deletedItem.id).then(
        () => {
          this.fArticles.splice(this.itemSelectedIndex, 1);
          this.closeDialog();
        },
        (error) => {
          console.log(error);
          this.snackBarMesage = "gagal hapus (digunakan oleh data anakk)";
          this.snackbar = true;
          this.$refs.refDeleteConfirmDialog.setDialogState(false);
        }
      );
    },
    deleteItemConfirmedMultiSelect(items) {
      if (items.length > -1) {
        let itemIds = [];
        for (let i = 0; i < items.length; i++) {
          itemIds.push(items[i].id);
        }
        FArticleService.deleteAllFArticle(itemIds).then(
          (response) => {
            if (response.data) {
              for (let i = 0; i < items.length; i++) {
                if (
                  !response.data.includes(items[i].id) ||
                  response.data.length === 0
                ) {
                  const index = this.fArticlesFiltered.indexOf(items[i]);
                  this.fArticles.splice(index, 1);
                }
                if (response.data.length > 0) {
                  this.snackBarMesage = `${response.data.length} items gagal hapus (digunakan oleh data anak)`;
                  this.snackbar = true;
                }
              }
              this.closeDialog();
            }
          },
          (error) => {
            console.log("error " + error);
          }
        );
      }
    },
    closeDialog() {
      this.formMode = "";
      this.$refs.refDeleteConfirmDialog.setDialogState(false);
      this.$refs.refFormDialog.setDialogState(false);

      this.$nextTick(() => {
        this.itemSelected = Object.assign({}, new FArticle());
        this.itemSelectedIndex = -1;
      });
    },

    getColorStatusActive(trueFalse) {
      if (trueFalse === true) return "green";
      else if (trueFalse === false) return "gray";
      else return "gray";
    },

    lookupFDivision(fdivisionBean) {
      const str = this.itemsFDivision.filter((x) => x.id == fdivisionBean);
      if (str.length > 0) {
        return str[0].description;
      } else {
        return "-";
      }
    },
    lookupFArticleCateg(farticleCategBean) {
      const str = this.itemsFArticleCateg.filter((x) => x.id == farticleCategBean);
      if (str.length > 0) {
        return str[0].description;
      } else {
        return "-";
      }
    },
    lookupImageUrl(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return require("@/assets/images/no_image_available.jpeg");
      } else {
        return FileService.image_url_low(item.avatarImage);
      }
    },
    lookupImageUrlLazy(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return require("@/assets/images/no_image_available.jpeg");
      } else {
        return FileService.image_url_verylow(item.avatarImage);
      }
    },
  },
  mounted() {
    this.fetchFCountry();
    this.fetchFArticle();
    this.fetchParent();
  },
};
</script>
  
  <style scoped>
</style>